import { render, staticRenderFns } from "./gzwx.vue?vue&type=template&id=1ddc76f5&scoped=true&"
import script from "./gzwx.vue?vue&type=script&lang=js&"
export * from "./gzwx.vue?vue&type=script&lang=js&"
import style0 from "./gzwx.vue?vue&type=style&index=0&id=1ddc76f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc76f5",
  null
  
)

export default component.exports